export function addItem<T=any>(arr: Array<T>, item: T){
    return [...new Set([...arr, item]) as any]
}
